import { network } from 'services/network';

export const getMFACode = ({ email }) => {
    const url = `admin/bo/getMFACode/${email}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
